import { createFileRoute } from '@tanstack/react-router';
import { ThreeDSPage } from '../components/pages/HomePage/ThreeDSPage';

export const Route = createFileRoute('/account/3ds_/$id_')({
  component: ThreeDSPage,
});
